<template src="./template/index.html"></template>
<script>
import Datepicker from "vuejs-datepicker";
import DibbleAPI from "../../../api";
import DibbleJS from "../../../dibble";
import DibbleApi from "@/api";
import $ from 'jquery';

export default {
    name: "RentalReportModal",
    props: {
        boatType: Number,
    },
    components: { Datepicker },
    data() {
        return {
            dibbleJs: DibbleJS,
            exportOptions: [
                { text: 'Day', value: 'day' },
                { text: 'Week', value: 'week' },
                { text: 'Month', value: 'month' },
                { text: 'Custom', value: 'custom' },
            ],
            exportOption: 'day',
            reportTypes: [],
            reportType: '',
            startDate: new Date(),
            endDate: new Date()
        }
    },
    created() {
        const params = {
            request: DibbleApi.api.getRentalReportTypes,
        };
        DibbleJS.callApiRequest(params, response => {
            if (DibbleApi.isResponseSuccess(response)) {
                this.reportTypes = response.rental_report_types
            } else {
                DibbleJS.toastErrorMessage(response.message);
            }
        });
    },
    methods: {
        changeSelection() {
            switch (this.exportOption) {
                case 'day': {
                    this.startDate = new Date()
                    this.endDate = new Date()
                    break
                }

                case 'week': {
                    const today = this.$moment()
                    this.startDate = today.startOf('isoweek').toDate()
                    this.endDate = today.endOf('isoweek').toDate()
                    break
                }

                case 'month': {
                    const today = this.$moment()
                    this.startDate = today.startOf('month').toDate()
                    this.endDate = today.endOf('month').toDate()
                    break
                }
            }
        },
        exportRental() {
            const params = {
                request: DibbleAPI.api.exportRentalReport,
                report_type: this.reportType.report_type_id,
                boat_type: this.boatType,
                from_date: this._formatDatetimeOutputForApi(this.startDate),
                to_date: this._formatDatetimeOutputForApi(this.endDate),
                token: DibbleJS.getStorageToken()
            }

            $('.extra-params').each(function () {
                if ($(this).val()) {
                    params[$(this).data('name')] = $(this).val();
                }
            });

            const requestEncoded = DibbleAPI.downloadUri[process.env.NODE_ENV] + Buffer.from(JSON.stringify(params)).toString("base64");
            const link = document.createElement('a')
            link.setAttribute('target', '_blank')
            link.setAttribute('href', requestEncoded)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        closeModal() {
            this.$emit("close");
        },
        customFormatter(date) {
            return this.$moment(date).format("MM/DD/YYYY");
        },
        _formatDatetimeOutputForApi(m) {
            return this.$moment(m).format("YYYY-MM-DD") + " 00:00:00";
        },
    }
}
</script>

<style lang="scss">
.modal {
    background: transparent;
    transition: opacity 0.15s linear;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;

    .modal-form {
        display: flex;
        height: auto;
        align-items: center;

        .content {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 8px;
            width: 100%;

            .title {
                font-size: 14px;
                margin: 0;
                margin-right: 10px;
            }
        }
    }

    button {
        float: right;
    }
}

.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.5s ease;
}

.input-extra-params {
    border: 1px solid #ced4da !important;
    width: 100% !important;
}

.modal-content {
    min-width: 500px !important;
}

.modal-content,
.modal-body {
    background: #C2D8DD !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.ok-btn {
    background: #2178ab;
    color: #ffffff;
}

.btn-dialog {
    width: 180px;
    height: 60px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 18px;
    text-align: space-between;
    color: #ffffff;
    border: none;

    &:disabled {
        opacity: 0.6;
    }
}
</style>
